<template>
  <div style="">
    <div v-if="!cookiesObject.token">
      <p class="someText" style="text-align: center; padding: 5px">
        {{ $t("LanguageEn.myTournamentsText1") }}
        <img
          src="@/assets/favorite1.png"
          style="width: 14px; margin-top: -4px"
          alt=""
        />
        {{ $t("LanguageEn.myTournamentsText2") }}
      </p>
    </div>
    <div
      class="hvr"
      style="background: #212226; padding-bottom: 1px; margin-bottom: 10px"
      v-else
    >
      <div v-if="favsT.length != 0">
        <div
          style="padding-top: 0px; padding-left: 8px"
          v-for="fav in favsT"
          :key="fav.id"
        >
          <p
            class="someText MobileHide simg"
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              height: 40px;
              padding-top: 10px;
            "
          >
            <img
              :src="defLogo + fav.category.id"
              style="
                width: 21px;
                margin-right: 5px;
                margin-left: 10px;
                margin-bottom: 3px;
              "
              alt=""
            />
            <router-link
              style="color: white"
              id="router-link"
              :to="{ name: 'LeaguePageNav', params: { leagueId: fav.id } }"
            >
              <span
                v-b-tooltip.hover
                :title="fav.name"
                v-if="ssize > 768 && ssize <= 992"
              >
                {{ fav.name.slice(0, 3) | transliterate(cookiesObject.lang) }}.
              </span>
              <span v-if="ssize > 992 && ssize <= 1200">
                <span v-if="fav.name.length < 13">{{ fav.name }} </span>
                <span v-b-tooltip.hover :title="fav.name" v-else
                  >{{
                    fav.name.slice(0, 10) | transliterate(cookiesObject.lang)
                  }}..</span
                >
              </span>
              <span v-else-if="ssize <= 768"></span>
              <span v-if="ssize > 1200">
                <span v-if="fav.name.length < 18"
                  >{{ fav.name | transliterate(cookiesObject.lang) }}
                </span>
                <span v-b-tooltip.hover :title="fav.name" v-else
                  >{{
                    fav.name.slice(0, 16) | transliterate(cookiesObject.lang)
                  }}..</span
                >
              </span>
            </router-link>
            <b-btn
              v-if="ssize > 772"
              v-on:click="(ids = fav.id), $refs['remove-modal3'].show()"
              style="
                float: right;
                background: none;
                border: none;
                margin-top: -7px;
              "
            >
              <img
                class="imag"
                src="@/assets/delete.png"
                style="width: 10px; margin-top: 6px"
                alt=""
              />
            </b-btn>
          </p>
          <p
            class="someText MobileShow"
            style="
              text-align: left;
              height: 25px;
              margin-left: 10px;
              padding-top: 10px;
            "
          >
            <img
              :src="defLogo + fav.category.id"
              style="width: 21px; margin-bottom: 5px; margin-right: 5px"
              alt=""
            />
            <router-link
              class="col"
              style="color: white"
              id="router-link"
              :to="{ name: 'LeaguePageNav', params: { leagueId: fav.id } }"
            >
              <span v-if="fav.name.length > 24"
                >{{
                  fav.name.slice(0, 24) | transliterate(cookiesObject.lang)
                }}..</span
              >
              <span v-else>{{ fav.name }}</span>
            </router-link>
            <b-btn
              v-on:click="(ids = fav.id), $refs['remove-modal3'].show()"
              style="
                float: right;
                background: none;
                border: none;
                margin-top: -7px;
              "
            >
              <img
                src="@/assets/delete.png"
                style="width: 10px; margin-bottom: 10px"
                alt=""
              />
            </b-btn>
          </p>
        </div>
        <div style="padding-top: 0px">
          <p
            v-b-modal.modal-search
            class="someText MobileHide"
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              height: 40px;
              padding-top: 10px;
              color: #3d8f41;
              padding-left: 10px;
              cursor: pointer;
              border-top: 1px solid #2c2d31;
            "
          >
            {{ $t("LanguageEn.addMore") }}
            <img
              src="@/assets/arright.png"
              style="
                width: 14px;
                margin-top: 5px;
                margin-right: 10px;
                float: right;
              "
              alt=""
            />
          </p>
        </div>
      </div>
      <div v-else>
        <p class="someText" style="text-align: center; padding: 5px">
          {{ $t("LanguageEn.myTournamentsText1") }}
          <img
            src="@/assets/favorite1.png"
            style="width: 14px; margin-top: -4px"
            alt=""
          />
          {{ $t("LanguageEn.myTournamentsText2") }}
        </p>
      </div>
    </div>
    <b-modal
      ref="remove-modal3"
      header-class="sureModal3"
      body-class="sureModal3"
      size="md"
      hide-footer
      centered
      title="Zunisport"
    >
      <p style="text-align: center; font-size: 12px; color: #a3a3a3">
        {{ $t("LanguageEn.removeTournament") }}
      </p>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class=""
            style="
              background: #bb4250;
              border: none;
              border-radius: 2px;
              width: 180px;
            "
            @click="
              removeFavorite({ value: ids, type: tournament }),
                $refs['remove-modal3'].hide()
            "
            >{{ $t("LanguageEn.remove") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Tournaments",
  data() {
    return {
      cookiesObject: "",
      defLogo: "https://sportapi.zuniac.com/category/logo/",
      favTeamId: "",
      leagueIden: "",
      tournament: "tournament",
      ssize: "",
      ids: "",
    };
  },

  async mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    // if (this.cookiesObject.token) {
    // this.getArrayT();
    // }

    window.addEventListener("resize", this.nowSize);
    this.nowSize();
  },

  destroyed() {
    window.removeEventListener("resize", this.nowSize);
  },
  methods: {
    ...mapActions(["getArray", "removeFavorite"]),
    nowSize() {
      this.ssize = window.innerWidth;
    },
  },

  props: {},
  computed: {
    ...mapGetters(["favsT"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.someText {
  color: white;
  font-size: small;
  background: #212226;
}
.someText:hover {
  background: #28292c;
}
.simg .imag {
  display: none;
}
.simg:hover .imag {
  display: block;
}

@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.sureModal3 {
  background: #212225;
  color: lightgrey;
  border: none;
  font-size: 12px !important;
}
.sureModal3 .modal-title {
  font-size: 15px !important;
}
.sureModal3 .close {
  color: white !important;
}
</style>
